import { ViewContentStatesComponent } from './view-content-states.component';

export default angular
  .module('sfMobile.components.view-content-states', [
    'sfMobile.components.spinner-floating',
  ])
  .component('sfViewContentStates', ViewContentStatesComponent).name;
